import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminBackgroundTaskContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeDeleted!: boolean;
}
